const Keys = {
    base_url: 'https://agrowize-backend-apis.onrender.com', 
    // base_url: 'http://localhost:6001',
};

export default Keys;